<template>
  <div class="bg-gradient-to-br from-blue-400 to-blue-500 text-white">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        <!-- Company Info -->
        <div>
          <img class="w-32 mb-4 rounded-lg" src="/img/logo.jpg" alt="MegaHissotto Logo" />
          <p class="text-sm">{{ t('footer.companyDescription') }}</p>
          <p class="mt-4 text-white hover:underline">
            <a href="https://www.google.com/maps/place/MEGA+HISSOTTO/@33.375805,-7.5861851,13.37z/data=!4m6!3m5!1s0xda63bc49df446e9:0x8d6c92716862c3e1!8m2!3d33.3734006!4d-7.5586628!16s%2Fg%2F11h_pf5hdv?entry=ttu&g_ep=EgoyMDI1MDIxMC4wIKXMDSoASAFQAw%3D%3D" target="_blank">
              {{ t('footer.viewOnMap') }}
            </a>
          </p>
        </div>

        <!-- Contact Info -->
        <div>
          <h3 class="text-xl font-semibold mb-4">{{ t('footer.contactTitle') }}</h3>
          <ul class="space-y-2">
            <li class="flex items-center">
              <i class="fas fa-map-marker-alt mr-2"></i>
              {{ t('footer.address') }}
            </li>
            <li class="flex items-center">
              <i class="fas fa-phone mr-2"></i>
              {{ t('footer.phone') }}
            </li>
            <li class="flex items-center">
              <i class="fas fa-fax mr-2"></i>
              {{ t('footer.fax') }}
            </li>
            <li class="flex items-center">
              <i class="fas fa-envelope mr-2"></i>
              info@megahissotto.com
            </li>
          </ul>
        </div>

        <!-- Newsletter Signup -->
        <div>
          <h3 class="text-xl font-semibold mb-4">{{ t('footer.newsletterTitle') }}</h3>
          <p class="mb-4 text-sm">{{ t('footer.newsletterDescription') }}</p>
          <form @submit.prevent="subscribeNewsletter" class="flex">
            <input 
              type="email" 
              v-model="email"
              :placeholder="t('footer.emailPlaceholder')" 
              class="flex-grow px-3 py-2 bg-white/20 text-white rounded-l-md focus:outline-none focus:ring-2 focus:ring-white/50 placeholder-white/70"
              required
            />
            <button 
              type="submit"
              class="bg-white text-blue-600 px-4 py-2 rounded-r-md hover:bg-blue-100 transition-colors focus:outline-none focus:ring-2 focus:ring-white/50 focus:ring-offset-2 focus:ring-offset-blue-600"
            >
              {{ t('footer.subscribe') }}
            </button>
          </form>
        </div>
      </div>

      <!-- Social Icons -->
      <div class="mt-8 pt-8 border-t border-white/20">
        <ul class="flex justify-center space-x-6">
          <li><a href="https://www.facebook.com/MegaHissottomaroc/" target="_blank" class="text-white/80 hover:text-white transition-colors"><i class="fab fa-facebook-f"></i></a></li>
          <li><a href="https://www.linkedin.com/company/mega-hissotto/?originalSubdomain=ma" target="_blank" class="text-white/80 hover:text-white transition-colors"><i class="fab fa-linkedin-in"></i></a></li>
          <li><a href="mailto:info@megahissotto.com" class="text-white/80 hover:text-white transition-colors"><i class="fas fa-envelope"></i></a></li>
        </ul>
      </div>

      <!-- Copyright -->
      <div class="mt-8 text-center text-sm">
        <p>&copy; {{ currentYear }} MegaHissotto. {{ t('footer.copyright') }}</p>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { useDataStore } from '@/stores/mainStore' // Import the store

const { t } = useI18n()
const currentYear = ref(new Date().getFullYear())
const email = ref('')
const store = useDataStore() // Initialize the store

const subscribeNewsletter = async () => {
  await store.subscribeUser(email.value) // Call the store action
  email.value = ''
}
</script>

<style scoped>
</style>
